import { render, staticRenderFns } from "./basketTab.vue?vue&type=template&id=1fb04621"
import script from "./basketTab.vue?vue&type=script&lang=js"
export * from "./basketTab.vue?vue&type=script&lang=js"
import style0 from "./basketTab.vue?vue&type=style&index=0&id=1fb04621&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports